import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, BoxContent, BoxFooter, Paragraph, Button } from 'components';
import './BoxCTA.scss';

class BoxCTA extends Component {
  render() {
    const { additionalClass, name, fixed } = this.props;

    return (
      <Box
        id={`contact-${name}`}
        link={'/contact#form'}
        backgroundColor={'yellow'}
        additionalClass={`box--imageless ${
          fixed ? '' : 'anim-fade-in-bottom'
        } ${additionalClass}`}
      >
        <BoxContent>
          <Paragraph
            size={'big'}
            color={'black'}
            additionalClass={'text--bold'}
          >
            {"Let's"} talk
          </Paragraph>
          <Paragraph additionalClass={'box-cta__description'}>
            {"We'd"} love to help with your product. Get in touch.
          </Paragraph>
        </BoxContent>
        <BoxFooter>
          <Button id={`contact-${name}`} color={'black'} transparent>
            Contact
          </Button>
        </BoxFooter>
      </Box>
    );
  }
}

BoxCTA.defaultProps = {
  additionalClass: '',
  fixed: false,
};

BoxCTA.propTypes = {
  additionalClass: PropTypes.string,
  name: PropTypes.string.isRequired,
  fixed: PropTypes.bool,
};

export default BoxCTA;
